// react-native-background-job -> timers while the page is open
const jobs = {};
const timers = {};

const BackgroundJob = {
  NETWORK_TYPE_UNMETERED: 2,
  NETWORK_TYPE_ANY: 0,
  NETWORK_TYPE_NONE: 1,

  register({ jobKey, job }) {
    jobs[jobKey] = job;
  },

  schedule({ jobKey, period = 900000 }) {
    BackgroundJob.cancel({ jobKey });
    if (!jobs[jobKey]) {
      return Promise.resolve();
    }
    timers[jobKey] = setInterval(() => {
      try {
        if (navigator.onLine !== false) {
          jobs[jobKey]();
        }
      } catch (e) {
        console.warn("background job failed", e);
      }
    }, Math.max(period, 60000));
    return Promise.resolve();
  },

  cancel({ jobKey }) {
    if (timers[jobKey]) {
      clearInterval(timers[jobKey]);
      delete timers[jobKey];
    }
    return Promise.resolve();
  },

  cancelAll() {
    Object.keys(timers).forEach(jobKey => BackgroundJob.cancel({ jobKey }));
    return Promise.resolve();
  },
};

export default BackgroundJob;
